import { captureException } from "@sentry/react";
import { Button, Container } from "reactstrap";
import Cookies from "js-cookie";

import AppPageHeader from "../../../../components/Headers/AppPageHeader";
import { newToastEvent } from "../../../../utils/ToastUtil";
import API from "../../../../api/api/API";

export default function SentryTesting() {
  return (
    <Container fluid>
      <div className="header pb-6">
        <AppPageHeader
          title="Sentry Testing"
          description="Intentionally throw errors to test Sentry"
        />
        <div className="tw:flex tw:flex-col tw:gap-4">
          <Button onClick={throwDashboardError} className="tw:w-fit">
            Throw GC-Dashboard Error
          </Button>
          <Button
            color="primary"
            onClick={throwAPIError}
            className="tw:w-fit ml-0"
          >
            Throw GC-API Error
          </Button>
        </div>
      </div>
    </Container>
  );

  async function throwDashboardError() {
    await captureException(
      new Error("Sentry Test Error Triggered By Supportal")
    );

    newToastEvent("success", "Success threw error from GC-Dashboard");
  }

  async function throwAPIError() {
    try {
      await API._bearerRequest(
        "GET",
        "/mc-tools/debug-sentry",
        null,
        Cookies.get(`authenticationToken`)
      );

      newToastEvent("success", "Successfully threw error from GC-API");
    } catch (e) {
      newToastEvent("error", "Failed to throw error from GC-API");
    }
  }
}
